import React from "react";

const DescriptionInput = ({ value, onChange }) => {
  return (
    <div className="form-group mb-3">
      <label htmlFor="segmentDescription" className="form-label fw-semibold">
        Description:
      </label>
      <textarea
        id="segmentDescription"
        className="form-control"
        placeholder="Enter a brief description of the segment..."
        rows={3}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default DescriptionInput;
